import React, { Component } from 'react'


import { Row, Col, Button, ButtonToolbar } from "react-bootstrap";
import OgaTable from "../OgaTables/OgaTable";
import Loader from "../elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import TopWidgetComponent from "./TopWidgetComponent";
import OgaSelect from "../elements/OgaSelect";
import AffiliateTypeahead from "components/Typeaheads/AffiliateTypeahead"


export default class Widget3 extends Component {

    values = [
        {
            id: 1,
            name: "Marius Lang",
            rank: "2",
            paymentRank: "2",
            status: "Al día",
            delay: "de 4 a 30 dias",
            telf: "8090923809",
            email: "weoirj@iwje.com",
        },
        {
            id: 2,
            name: "Sebastian Antelo",
            rank: "1",
            paymentRank: "1",
            status: "En Mora",
            delay: "En mora",
            telf: "8090923809",
            email: "weoirj@iwje.com",
        },
        {
            id: 3,
            name: "Otro",
            rank: "2",
            paymentRank: "2",
            status: "Al día",
            delay: "de 4 a 30 dias",
            telf: "8090923809",
            email: "weoirj@iwje.com",
        }];

    httpClient;
    numOfPages = 0;
    NUM_OF_ROWS = 10;
    currentPage = 1;
    constructor(props) {
        super(props);
        this.state = {
            methods: null,
            checked: false,
            loading: false,
            loaded: false,
            values: null,
            selectedAffiliate: ""
        };
        this.httpClient = new HttpClient(true);
    }

    customerId;
    status;
    componentWillMount() {
        this.updateTable();
    }

    updateTable() {
        let url = `oga/widgets/affiliates-detail?quantityRows=${this.NUM_OF_ROWS}&pageNumber=${this.currentPage}`;

        if (this.customerId) {
            url += `&customerId=${this.customerId}`
        }

        if (this.status && this.status !== 'ALL') {
            url += `&status=${this.status}`
        }

        this.httpClient.get(url).then((res) => {
            console.log("CALL SUCCESS", res.data);
            this.setState({ loaded: true, loading: false, values: res.data });
        }).catch((err) => {
            console.error("CALL FAIL", err);
            this.setState({ loaded: true, loading: false });
        })
    }

    onPageChange = (pageNumber) => {
        this.setState({ loading: true });
        this.currentPage = pageNumber + 1;
        this.updateTable();
    };

    onAffiliateChange(e) {
        this.customerId = e.id;
        this.updateTable();
    }
    onStateChange(e) {
        this.status = e.value;
        this.updateTable();
    }


    STATES = {
        ALL: "Todos",
        ENABLE: "Al día",
        DISABLED: "En Mora",
        OFF: "En Ejecución"
    };

    selectValues(val) {
        let arr = [];
        Object.keys(val).forEach(e => arr.push({ value: e, label: val[e] }));
        return arr;
    }

    PDFReport() {
        this.requestReport('pdf');
    }

    XLSReport() {
        this.requestReport('xls');
    }

    requestReport(ext) {
        let excelParam = ext === 'xls' ? '?excel=true' : '?excel=false';
        let url = `oga/report/affiliates-detail${excelParam}`;

        if (this.customerId) {
            url += `&customerId=${this.customerId}`
        }

        if (this.status && this.status !== 'ALL') {
            url += `&status=${this.status}`
        }

        this.httpClient.get(url, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.' + ext);
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                console.error("oga/report/affiliates-detail Error", err);
            })
    }

    render() {
        let loaded = this.state.loaded;
        console.log("isdashboard", this.props);
        let stateValues = this.selectValues(this.STATES);
        return (
            <div className="widget-container w-100">
                {
                    !loaded ?
                        <div className={"w-100 centered"} style={{ minHeight: "400px" }}>
                            <Loader show={true} />
                        </div> :
                        <div>
                            <Row className="widget-container-padding">
                                <Col md={12} className={"no-padding no-margin"}>
                                    <form>
                                        <TopWidgetComponent id={this.props.id}
                                            label={this.props.name}
                                            onSelectionChange={(val, id) => this.props.onSelectionChange(val, id)}
                                            isDashboard={this.props.isDashboard} />

                                        <div className="widget-from-input-container flex-row">
                                            <AffiliateTypeahead
                                                className="flex-grow right-4"
                                                onRef={ref => (this.customerTypeahead = ref)}
                                                selection={this.state.selectedAffiliate}
                                                onAffiliateChange={(affiliate) => this.onAffiliateChange(affiliate)} />

                                            <OgaSelect className="flex-grow left-4"
                                                options={stateValues}
                                                onChange={(e) => this.onStateChange(e)}
                                                placeholder="Estado" />
                                        </div>
                                    </form>
                                </Col>
                                <Col md={12} className={"no-padding no-margin bottom-margin-8 top-margin-8"}>
                                    <ButtonToolbar className="float-right">
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.PDFReport()}>PDF</Button>
                                        &nbsp;&nbsp;
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.XLSReport()}>Excel</Button>
                                    </ButtonToolbar>
                                </Col>
                                <Col md={12} className={"no-padding no-margin"}>
                                    <OgaTable
                                        loading={this.state.loading}
                                        headers={["Nombre", "Patrocinador","Rango", "Rango pago", "Estado", "Días Mora", "Telf.", "Correo","Cuotas Mora","Monto Cuota","Total Deuda"]}
                                        properties={["customerName","owner","rank", "paymentRank", "status", "arrearsDays", "phone", "email","delayedQuotas","quotaAmount","totalDebt"]}
                                        pullRight={[4]}
                                        format={[{ range: 4, parse: (value) => this.STATES[value]}]}
                                        pageCount={!this.state.values ? null : this.state.values.count}
                                        onPageChange={this.onPageChange}
                                        values={!this.state.values ? null : this.state.values.affiliates} />
                                </Col>
                            </Row>
                        </div>
                }
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Widgets/Widget3.jsx